import { instance } from "apis/interceptor";
import axios from "axios";

export const generateGoogleAccessToken = async (
  authorizationCode: string,
  redirectUri: string
): Promise<{ success: boolean; googleAccessToken?: string; error?: string; googleRefreshToken?: string }> => {
  try {
    const res = await instance.post("/auth/google/oauth", {
      authorizationCode: authorizationCode,
      redirectUri: redirectUri,
    });
    const { googleAccessToken, googleRefreshToken } = res.data;
    return { success: true, googleAccessToken: googleAccessToken, googleRefreshToken: googleRefreshToken };
  } catch (error: any) {
    return { success: false, error: `${error}` };
  }
};

export const getGoogleEmailWithAccessToken = async (
  googleToken: string
): Promise<{ success: boolean; email?: string | null }> => {
  try {
    const response = await fetch(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${googleToken}`);
    const data = await response.json();
    return { success: true, email: data.email };
  } catch (error) {
    return { success: false, email: null };
  }
};
